<template>
  <Header />
  <div class="flex h-full flex-col items-center lg:bg-blue-lighter">
    <div
      class="mb-20 mt-10 w-full !max-w-[768px] overflow-hidden bg-white p-0 pb-4 lg:mt-20 lg:rounded-3xl lg:pb-[79px]"
    >
      <IntroBlock v-if="introBlock" :data="introBlock" class="mb-4 mt-5 lg:mt-[50px]" />
    </div>
  </div>
  <Footer />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { IntroBlock } from 'refresh-ui'
import Footer from '@/components/elements/SimpleFooter.vue'
import Header from '@/components/elements/SimpleHeader.vue'
import type { ErrorData } from '~/types/error'
const { t, te } = useI18n()

const props = defineProps<{ error: ErrorData }>()

const introBlock = computed(() => {
  const code = props.error.statusCode
  let title = props.error.data?.title
  if (!title) {
    const key = `error.${code}.title`
    title = te(key) ? t(key) : t('error.unknown.title')
  }
  return {
    id: 'error-act',
    subtitle: String(props.error?.statusCode || t('error.unknown.code')),
    title: props.error?.data?.title
      ? props.error.data.title
      : props.error?.statusCode
        ? t(`error.${props.error.statusCode}.title`)
        : t('error.unknown.title'),

    copy:
      props.error.data?.text ||
      props.error.message ||
      props.error.statusMessage ||
      t('error.unknown.text'),
    position: 'center',
    link:
      props.error.data?.buttonUrl && props.error.data?.buttonText
        ? {
            type: 'int' as const,
            title: props.error.data.buttonText,
            url: props.error.data.buttonUrl,
          }
        : undefined,
  } as any
})
</script>
